<div class="sb-side-menu-action">
  <ng-content></ng-content>
</div>
